import { render, staticRenderFns } from "./nutritionDetection.vue?vue&type=template&id=4a0dd770"
import script from "./nutritionDetection.vue?vue&type=script&lang=js"
export * from "./nutritionDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0dd770')) {
      api.createRecord('4a0dd770', component.options)
    } else {
      api.reload('4a0dd770', component.options)
    }
    module.hot.accept("./nutritionDetection.vue?vue&type=template&id=4a0dd770", function () {
      api.rerender('4a0dd770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Nutrition/manage/nutritionDetection.vue"
export default component.exports